import { UNITED_KINGDOM } from '../constants'

const isLocationUnitedKingdom = (location) => location === UNITED_KINGDOM

export default isLocationUnitedKingdom
